var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"fmhind-tab-general"},[_c('div',{staticClass:"fmhind-tab-general__column"},[_c('Sectors',{staticClass:"fmhind-tab-general__chart"}),_c('GeneralAndSpecialistDoctors',{staticClass:"fmhind-tab-general__chart"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }